import {Box, Center, Text, Link, Button} from '@chakra-ui/react';

export const FiveStandLeagueInfo = () => {
  const pdfUrl = "https://ggc-website-public-content.s3.us-east-2.amazonaws.com/GGC+2026+Spring+5-Stand+League+Flyer.pdf";
  
  return (
    <Box mt={6}>
      <Center>
        <Text as="h3" color="#000000" fontSize={{ base: '22px' }} fontWeight="600">Five Stand League Information</Text>
      </Center>
      <Box mt={4} mb={4}>
        <Center mb={4}>
          <Button as="a" href={pdfUrl} target="_blank" rel="noopener noreferrer" colorScheme="blue">
            Open PDF in New Tab
          </Button>
        </Center>
        <object
          data={pdfUrl}
          type="application/pdf"
          width="100%"
          height="800px"
          style={{ border: 'none' }}
        >
          <Box p={4} textAlign="center">
            <Text mb={2}>Unable to display PDF.</Text>
            <Link href={pdfUrl} target="_blank" rel="noopener noreferrer" color="blue.500">
              Click here to download the Five Stand League Information PDF
            </Link>
          </Box>
        </object>
      </Box>
      <Box>For more information about Five Stand League, contact <Link href="mailto:competitions@goldengunclub.us">competitions@goldengunclub.us</Link></Box>
    </Box>
  );
};